export default __webpack_public_path__ + "static/media/movipack_feature5.2fa053da.svg";